<div id="card-items" class="py-10 mb-[2rem]">
  <div class="container px-5">
    <h2 class="mb-5 font-bold xl:text-5xl lg:text-4xl md:text-3xl text-2xl text-center">
      How to Use Revision Notes Effectively

    </h2>
    <h3 class="mb-[5rem] text-center text-[18px]">
      Want to make your revision more efficient and boost your exam results? Follow these three
      simple steps to get the most out of our expertly designed notes.
    </h3>

    <div class="flex flex-wrap justify-center">
      @for (item of cardItems; track $index) {
      <div class="w-full md:w-1/2 lg:w-1/3 px-4 mb-6 h-auto">
        <app-card-item [cardItem]="item" />
      </div>
      }
    </div>
  </div>
</div>